import React from 'react';
import './OverviewCards.css';
import { formatNumber } from '../../../utils/analyticsHelpers';

// Generic overview card strip. Pass whichever metrics apply for the
// dashboard using it - the support-admin dashboard shows 4 cards
// (Users/Sessions/Searches/Trip Views), while the organizer dashboard
// drops "Searches" since search events aren't tied to a specific trip.
const OverviewCards = ({ cards = [] }) => {
    return (
        <div className={`analyticsCards${cards.length !== 4 ? ` cols-${cards.length}` : ''}`}>
            {cards.map((card) => (
                <div className='analyticsCard' key={card.label}>
                    <span>{card.label}</span>

                    <strong>{formatNumber(card.value)}</strong>
                </div>
            ))}
        </div>
    );
};

export default OverviewCards;
